import { mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 212px;

  @media (${mobileXXLargeMax}) {
    flex-basis: calc(50% - 5px);
  }
`;

export const Title = styled.h2`
  font-size: 16px;
  color: ${({ theme }) => theme.textDark};

  a:hover {
    text-decoration: underline;
  }
`;

export const MarketLinks = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.textDark};
  margin-bottom: 5px;
  display: flex;
  flex-direction: column;

  a:hover {
    text-decoration: underline;
  }
`;
